import { availabilityIcon, genetic } from './mapper.js';
import { getItemURL, getItemAvailability, getItemBruttoRetailPrice, getItemInventoryID } from './articles.js';
import { Directus } from '@directus/sdk';
import userstore from './../store/stores/userstore';
import { date } from './mapper';
import { getProductDetails, safeParseString } from './utils.js';


export function mapBudInventory(item) {
        if (item.inventory && item.inventory.length) {
                item.inventory.sort((a, b) => {
                        if (a.availability !== b.availability) {
                                return b.availability - a.availability;
                        }

                        // return (a.brutto_retail_price || Infinity) - (b.brutto_retail_price || Infinity);
                });
                
                const bestInventoryItem = getProductDetails(item.inventory) || {};
                const {
                        id,
                        brutto_retail_price,
                        availability,
                        price_regulation,
                        prescription_provider,
                        hide_on_wla,
                        expiry,
                        netpurchaseprice_per_unit
                } = bestInventoryItem;

                item.mapped = {
                        inventory: item.inventory,
                        item: {
                                productID: item.item.id,
                                price_regulation: price_regulation,
                                prescription_provider: prescription_provider,
                                itemInventoryID: id || false,
                                bruttoRetailPrice: Number(brutto_retail_price) || false,
                                sliderPrice: brutto_retail_price || false,
                                availability: availability || false,
                                availabilityIcon: availabilityIcon(availability || false),
                                thc: `${item.item.equality_thc || ''}${item.item.thc || ''}`,
                                cbd: `${item.item.equality_cbd || ''}${item.item.cbd || ''}`,
                                manufacturer: item.item.manufacturer?.name || 'n.a',
                                cultivar: item.item.cultivar || 'n.a',
                                genetic: genetic(item.item.genetic),
                                dominance: genetic(item.item.dominance),
                                origin_country: item.item.origin_country,
                                url: getItemURL(item.inventory) || '',
                                hide_on_wla: hide_on_wla,
                                radiationstate: item.item.radiationstate,
                                netpurchaseprice_per_unit : netpurchaseprice_per_unit ? safeParseString(netpurchaseprice_per_unit) + ' €' : "n.a.",
                                expiryDate : expiry ? date(expiry, "DD.MM.YYYY") : "n.a."
                        }
                };
        } else {
                item.mapped = {
                        inventory: [],
                        item: {
                                productID: item.item.id,
                                prescription_provider: item.prescription_provider,
                                itemInventoryID: false,
                                bruttoRetailPrice: false,
                                sliderPrice: false,
                                availability: false,
                                availabilityIcon: availabilityIcon(false),
                                thc: `${item.item.equality_thc || ''}${item.item.thc || ''}`,
                                cbd: `${item.item.equality_cbd || ''}${item.item.cbd || ''}`,
                                manufacturer: item.item.manufacturer?.name || 'n.a',
                                cultivar: item.item.cultivar || 'n.a',
                                genetic: genetic(item.item.genetic),
                                dominance: genetic(item.item.dominance),
                                origin_country: item.item.origin_country,
                                url: getItemURL(item.inventory) || '',
                                radiationstate: item.item.radiationstate,
                                netpurchaseprice_per_unit : "n.a.",
                                expiryDate : "n.a."
                        }
                };
        }

        return item;
}

// export function recalculateFlowerPrice(items,amount = 1) {
//   const length = items.length-1;
//   for(let i = 0; i <= length; i++ ){
//     console.log(items[i].mapped.item.sliderPrice, amount);
//     const netpurchasepricePerUnit = 2;
//     if(netpurchasepricePerUnit !== null && typeof netpurchasepricePerUnit !== 'undefined'){
//       // const price = calculateFlowerPrice(items[i].item.customer_min_price, amount);
//       // items[i].mapped.item.sliderPrice = price.new_total.toFixed(2);
//       items[i].mapped.item.sliderPrice = (items[i].mapped.item.bruttoRetailPrice * amount).toFixed(2);
//     }
//   }
// }

export function recalculateFlowerPrice(items,amount = 1) {
  const length = items.length-1;
  for(let i = 0; i <= length; i++ ){
    const netpurchasepricePerUnit = items[i].mapped.item.bruttoRetailPrice;
    if(netpurchasepricePerUnit !== null && typeof netpurchasepricePerUnit !== 'undefined'){
      // const price = calculateFlowerPrice(Number(items[i].mapped.item.bruttoRetailPrice), Number(amount));
      const price = calculateBestPrice(Number(items[i].mapped.item.bruttoRetailPrice), Number(amount), items[i].priceRegulation);
      // console.log(Number(items[i].mapped.item.bruttoRetailPrice), Number(amount), items[i].priceRegulation);
      items[i].mapped.item.sliderPrice = price.total.toFixed(2);
    }
  }
}

export function calculateBestPrice(price, amount, priceRegulation) {
  // 1) Validate inputs
  if (typeof price !== 'number' || typeof amount !== 'number') {
    console.error('❌ Invalid price or amount:', { price, amount, priceRegulation });
    return null;
  }

  // 2) Simple path when no regulation
  if (!priceRegulation) {
    const total = price * amount;
    return {
      total:        Number(total.toFixed(2)),
      pricePerGram: Number((total / amount).toFixed(2)),
      method:       'Simple'
    };
  }

  // 3) Regulated path: override base unit-price with tier1Cost
  const tier1Limit = 15;
  const tier2Limit = 15;
  const tier1Cost  = 9.52;  // also your “default purchase price” per gram
  const tier2Cost  = 3.7;
  const tier3Cost  = 2.6;

  // — compute “additional” cost across the three tiers
  let remaining      = amount;
  let additionalCost = 0;

  // Tier 1 extra
  const t1 = Math.min(remaining, tier1Limit);
  additionalCost += t1 * tier1Cost;
  remaining     -= t1;

  // Tier 2 extra
  const t2 = Math.min(remaining, tier2Limit);
  additionalCost += t2 * tier2Cost;
  remaining     -= t2;

  // Tier 3 extra
  const t3 = Math.max(remaining, 0);
  additionalCost += t3 * tier3Cost;

  // 4) Regulated total = (tier1Cost × amount) + additionalCost
  const regulatedTotal     = (tier1Cost * amount) + additionalCost;
  const regulatedPerGram   = regulatedTotal / amount;

  const simpleTotal = price * amount;
  const simplePricePerGram = simpleTotal / amount;

  const isRegulatedCheaper = regulatedTotal * 1.19 < simpleTotal;

  return {
    // total:        Number(regulatedTotal.toFixed(2)),
    // pricePerGram: Number(regulatedPerGram .toFixed(2)),
    total: Number((isRegulatedCheaper ? regulatedTotal * 1.19 : simpleTotal).toFixed(2)),
    pricePerGram: Number((isRegulatedCheaper ? regulatedPerGram : simplePricePerGram).toFixed(2)),
    method: isRegulatedCheaper ? 'Regulated' : 'Simple'
  };
}

// export function calculateBestPrice( price, amount, priceRegulation ) {
//
//   if (typeof price !== 'number' || typeof amount !== 'number') {
//     console.error('❌ Invalid price or amount:', { price, amount, priceRegulation });
//     return null;
//   }
//
//   if (!priceRegulation) {
//     const total = price * amount;
//     return {
//       total: parseFloat(total.toFixed(2)),
//       pricePerGram: parseFloat((total / amount).toFixed(2)),
//       method: 'Simple'
//     };
//   }
//
//   // Regulated pricing
//   const tier1Limit = 15;
//   const tier2Limit = 15;
//   const tier1Cost = 9.52;
//   const tier2Cost = 3.7;
//   const tier3Cost = 2.6;
//
//   let remaining = amount;
//   let additionalCost = 0;
//
//   // Tier 1
//   const tier1Grams = Math.min(remaining, tier1Limit);
//   additionalCost += tier1Grams * tier1Cost;
//   remaining -= tier1Grams;
//
//   // Tier 2
//   const tier2Grams = Math.min(remaining, tier2Limit);
//   additionalCost += tier2Grams * tier2Cost;
//   remaining -= tier2Grams;
//
//   // Tier 3
//   const tier3Grams = Math.max(remaining, 0);
//   additionalCost += tier3Grams * tier3Cost;
//
//   const regulatedTotal = (price * amount) + additionalCost;
//   const regulatedPricePerGram = regulatedTotal / amount;
//
//   const simpleTotal = price * amount;
//   const simplePricePerGram = simpleTotal / amount;
//
//   const isRegulatedCheaper = regulatedTotal < simpleTotal;
//
//   return {
//     total: Number((isRegulatedCheaper ? regulatedTotal : simpleTotal).toFixed(2)),
//     pricePerGram: Number((isRegulatedCheaper ? regulatedPricePerGram : simplePricePerGram).toFixed(2)),
//     method: isRegulatedCheaper ? 'Regulated' : 'Simple'
//   };
// }

export function calculateFlowerPrice(pricePerUnit, amount = 1) {
  const priceMatrix = {
    base: 9.52,
    first_level: 3.70,
    second_level: 2.60,
  };
  const basePrice = pricePerUnit.toPrecision(4) * amount;
  const calculatedPrice = (priceMatrix.base * amount) + (priceMatrix.base * (amount > 15 ? 15.0 : amount)) + (priceMatrix.first_level * (amount > 30 ? 15 : (amount - 15 < 0 ? 0 : amount - 15.0))) + (priceMatrix.second_level * (amount > 30 ? amount - 30.0 : 0));
  const total = (calculatedPrice < basePrice ? (calculatedPrice) * 1.19 : basePrice);
  console.log((calculatedPrice) * 1.19, basePrice);
  const calcPricePerUnit = (total / Number.parseFloat(amount) ) * 1.19;

  const new_total = parseFloat( total.toPrecision(4) );
  return {
    new_total,
    calcPricePerUnit,
  };
}

const delay = (delayInms) => {
  return new Promise(resolve => setTimeout(resolve, delayInms));
};

/**
 * Update inventory item by item id
 */
async function updateInventoryItemById( id, body ) {
  // Get Directus
  const token = localStorage.getItem('greeners_auth_token');
  const directus = new Directus(process.env.GREENERS_URL,{
    auth: {
        staticToken: token,
    },
    storage: {
      prefix: 'greeners_',
      mode: 'LocalStorage',
    },
  });

  const { greeners } = userstore.state;
  if (!greeners.id) {
          const user = await directus.users.me.read();
          userstore.commit('user/greeners', { ...user });
  }

  await directus.items('inventory').updateOne(id, body);
}

/**
 * Update bud item by product id
 */
export async function updateBudItemById( id, product, user_id ) {
  // Setup filters to search inventory item
  let filters = JSON.stringify({
    _and: [
      { product_id: { _eq: id } },
      { user_created: { _eq: user_id } }
    ]
  });

  const token = localStorage.getItem('greeners_auth_token');
  // Execute request
  await fetch(`${process.env.GREENERS_URL}items/inventory?filter=${filters}`, {
    method: 'GET',
    headers: new Headers({
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }),
  }).then( (res) => {
    return res.json()
  } ).then( (result) => {
    // Update inventory item if ok
    if ( result.data.length !== 0 && result.data[0].length !== 0 ) {
      let item_data = result.data[0];
      let item_id = item_data.id;

      // Prepare body for request
      let body = {
        availability: product.availability,
        brutto_retail_price: product.price,
      };
      updateInventoryItemById( item_id, body );
    }
  });
}

/**
 * Get bud item by pzn
 */
export async function getBudItemByPzn( product, user_id ) {
  let filters = JSON.stringify({
    _and: [
      {
        pzns: {
          _contains: product.pzn
        }
      }
    ]
  });

  const token = localStorage.getItem('greeners_auth_token');
  // Get bud
  let result = await fetch(`${process.env.GREENERS_URL}/items/buds?filter=${filters}`, {
    method: 'GET',
    headers: new Headers({
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    })
  }).then( (res) => {
    return res.json();
  }).then( (result) => {
    if ( result.data.length !== 0 && result.data[0] !== null ) {
      let bud_id = result.data[0].id;
      updateBudItemById( bud_id, product, user_id );
      return true;
    } else {
      return false;
    }
  } );

  return result;
}
